var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33366 1C6.15817 1 5.1857 1.86924 5.02395 3H4.01014H3.99251H3.33366H2.66699C2.11471 3 1.66699 3.44772 1.66699 4C1.66699 4.55228 2.11471 5 2.66699 5H3.06533L3.5908 12.8122L3.59097 12.8149C3.66915 14.0434 4.68834 15 5.91959 15H10.0811C11.3123 15 12.3315 14.0434 12.4097 12.8149L12.4098 12.8122L12.9353 5H13.3337C13.8859 5 14.3337 4.55228 14.3337 4C14.3337 3.44772 13.8859 3 13.3337 3H12.667H12.0081H11.9905H10.9767C10.815 1.86924 9.84248 1 8.66699 1H7.33366ZM7.46608 6.62385C7.44243 6.07207 6.97595 5.64394 6.42417 5.66758C5.8724 5.69123 5.44426 6.15771 5.46791 6.70948L5.66791 11.3762C5.69156 11.9279 6.15803 12.3561 6.70981 12.3324C7.26159 12.3088 7.68972 11.8423 7.66608 11.2905L7.46608 6.62385ZM10.5327 6.70948C10.5564 6.15771 10.1283 5.69123 9.57648 5.66758C9.0247 5.64394 8.55822 6.07207 8.53458 6.62385L8.33458 11.2905C8.31093 11.8423 8.73906 12.3088 9.29084 12.3324C9.84262 12.3561 10.3091 11.9279 10.3327 11.3762L10.5327 6.70948Z",
    fill: "#F38D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDeleteIcon);
export default __webpack_public_path__ + "static/media/upload-delete-icon.cf723b614bb2fce49548106046899b9e.svg";
export { ForwardRef as ReactComponent };